import { FormFields, Steps } from './enums/module';

export const stepToFormFieldRecord: Record<Steps, FormFields> = {
	[Steps.One]: FormFields.BeginCheckout,
	[Steps.Two]: FormFields.SubmitContactInfo,
	[Steps.Three]: FormFields.SubmitBillingInfo,
	[Steps.Four]: FormFields.AddPaymentInfo,
	[Steps.Five]: FormFields.Invoice
};
